<template>
  <b-modal size="lg" :visible="visible" centered no-close-on-backdrop no-close-on-esc>
    <div slot="modal-header" class="w-100">
      <h5>Finalize Estimate
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center m-2">
      <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
        <div>{{ generalErrorMessage }}</div>
      </div>
      </div>
      <div class="row">
        <div class="col-2">
        </div>
        <div class="col-8 pb-3">
        <font-awesome-icon size="sm" class="text-warning mr-2 align-baseline" icon="exclamation-triangle"/> Once an estimate has been finalized, you will no longer be able to edit the estimate. Please make sure all information is
        correct and insurance benefits are up to date.
      <br><br>
        <b>Finalize the estimate and send a notification to the patient to review and make a payment?</b>
    </div>
        </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="FinalizeEstimate()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>Finalize and Send</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '@/services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import _ from 'lodash'

  export default {
    name: 'FinalizeEstimateModal',

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      estimate: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        patientEstimate: {},
        isSaving: false
      }
    },

    mixins: [ErrorsMixin],

    methods: {

      closeModal () {
        this.$emit('update:visible', false)
      },

      FinalizeEstimate () {
        const value = !this.patientEstimate.finalized

        this.clearAllErrors()
        api.post('/Dashboard/Estimate/' + this.patientEstimate.organizationPatientEstimateId + '/Finalize/' + value).then(response => {
          this.$emit('updated')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to update estimate: ' + error.message, error)
            this.addErrorForField('exception', error.message)
          }
        })
      }
    },

    watch: {
      estimate (newValue) {
        this.patientEstimate = _.clone(newValue)
      }
    }
  }
</script>
